import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { PrintApiKey, printApiMap } from './api-map';

export default [
  {
    name: 'SLAPrint',
    /**
     * 当前业务类型
     */
    businessType: '',

    status: {
      /**
       * 打印接口错误数量
       */
      apiErrorCount: 0,
      /**
       * 健康检查错误数量
       */
      healthCheckErrorCount: 0,
      /**
       * 打印机错误数量
       */
      printerErrorCount: 0,
    },
    collector: {} as TransactionCollector,

    // 耗时埋点
    /**
     * 全流程耗时
     */
    ALLName: 'custom_WMSPrint',
    /**
     * 打印接口耗时
     */
    ApiPrintTime: 'custom_WMSPrint_api_print_time',
    /**
     * 健康检查耗时
     */
    HealthCheckTime: 'custom_WMSPrint_health_check_time',
    /**
     * 打印机耗时
     */
    PrinterPrintTime: 'custom_WMSPrint_printer_print_time',
    /**
     * 打印接口错误数量上报
     */
    ApiErrorCount: 'custom_WMSPrint_api_error_count',
    /**
     * 健康检查错误数量上报
     */
    HealthCheckErrorCount: 'custom_WMSPrint_health_check_error_count',
    /**
     * 打印机错误数量
     */
    PrinterErrorCount: 'custom_WMSPrint_printer_error_count',
    /**
     * 全流程错误数量上报
     */
    ErrorCount: 'custom_WMSPrint_error_count',

    getPointList: function () {
      return [
        /**
         * 监听流程耗时开始
         */
        {
          type: ActionType.REQUEST,
          rule: {
            // eslint-disable-next-line no-useless-escape
            url: /^\/api\/v2\/apps\/.*\/print_[^\/]*/,
            state: RequestState.Before,
          },
          handler: (trackData: any, _: any) => {
            this.collector = DataCollectorInstance.createTransactionCollector();

            this.status.apiErrorCount = 0;
            this.status.healthCheckErrorCount = 0;
            this.status.printerErrorCount = 0;

            const url = trackData?.params?.request?.url || '';
            this.businessType = printApiMap[url as PrintApiKey];
            /**
             * 开始全流程耗时
             */
            this.collector.startTrack({
              name: this.ALLName,
            });
            /**
             * 开始打印接口耗时
             */
            this.collector.startTrack({
              name: this.ApiPrintTime,
            });
          },
        },
        // 监听健康检查耗时开始
        {
          type: ActionType.REQUEST,
          rule: {
            url: 'https://printproxy.wms.shopeemobile.com:21317/api/version',
            state: RequestState.Before,
          },
          handler: (trackData: any, _: any) => {
            /**
             * 开始健康检查耗时
             */
            this.collector.startTrack({
              name: this.HealthCheckTime,
            });
          },
        },
        // 监听打印机接口耗时开始
        {
          type: ActionType.REQUEST,
          rule: {
            url: /https:\/\/printproxy\.wms\.shopeemobile\.com:21317\/api(\/v2)?\/print/,
            state: RequestState.Before,
          },
          handler: (trackData: any, _: any) => {
            /**
             * 开始打印机接口耗时
             */
            this.collector.startTrack({
              name: this.PrinterPrintTime,
            });
          },
        },

        // 监听打印接口请求完成
        {
          type: ActionType.REQUEST,
          rule: {
            // eslint-disable-next-line no-useless-escape
            url: /^\/api\/v2\/apps\/.*\/print_[^\/]*/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            // console.log('trackData 监听打印接口请求完成', trackData);
            // console.log('trackData 监听打印接口请求完成', response);

            let isSuccess = true;
            if (response?.retcode !== 0) {
              this.status.apiErrorCount += 1;
              isSuccess = false;
            }

            const [result] = this.collector.endTrackByName({
              name: this.ApiPrintTime,
              isSuccess,
            });
            sendDataFn({
              pointId: result.name,
              customData: {
                data: { business_type_s: this.businessType },
                ...result,
                type: 'experienceTime',
              },
            });
          },
        },
        // 监听健康检查请求完成
        {
          type: ActionType.REQUEST,
          rule: {
            url: 'https://printproxy.wms.shopeemobile.com:21317/api/version',
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            // console.log('trackData 监听健康检查请求完成', trackData);
            // console.log('trackData 监听健康检查请求完成', response);

            let isSuccess = true;
            if (response?.retcode !== 0) {
              this.status.healthCheckErrorCount += 1;
              isSuccess = false;
            }

            const [result] = this.collector.endTrackByName({
              name: this.HealthCheckTime,
              isSuccess,
            });
            sendDataFn({
              pointId: result.name,
              customData: {
                data: { business_type_s: this.businessType },
                ...result,
                type: 'experienceTime',
              },
            });
          },
        },
        // 监听打印机接口请求完成
        {
          type: ActionType.REQUEST,
          rule: {
            url: /https:\/\/printproxy\.wms\.shopeemobile\.com:21317\/api(\/v2)?\/print/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            // console.log('trackData 监听打印机接口请求报错', trackData);
            // console.log('trackData 监听打印机接口请求报错', response);

            let isSuccess = true;
            if (response?.retcode !== 0) {
              this.status.printerErrorCount += 1;
              isSuccess = false;
            }

            // 结束打印机接口耗时
            const [result] = this.collector.endTrackByName({
              name: this.PrinterPrintTime,
              isSuccess,
            });
            sendDataFn({
              pointId: result.name,
              customData: {
                data: { business_type_s: this.businessType },
                ...result,
                type: 'experienceTime',
              },
            });

            // 结束全流程耗时
            const [allResult] = this.collector.endTrackByName({
              name: this.ALLName,
              isSuccess,
            });
            sendDataFn({
              pointId: allResult.name,
              customData: {
                data: { business_type_s: this.businessType },
                ...allResult,
                type: 'experienceTime',
              },
            });

            // 上报所有错误数量
            sendDataFn({
              pointId: this.ErrorCount,
              customData: {
                data: { business_type_s: this.businessType },
                errorCount_n:
                  this.status.apiErrorCount +
                  this.status.healthCheckErrorCount +
                  this.status.printerErrorCount,
                type: 'experienceCount',
              },
            });
            // 上报打印接口错误数量
            sendDataFn({
              pointId: this.ApiErrorCount,
              customData: {
                data: { business_type_s: this.businessType },
                errorCount_n: this.status.apiErrorCount,
                type: 'experienceCount',
              },
            });
            // 上报健康检查错误数量
            sendDataFn({
              pointId: this.HealthCheckErrorCount,
              customData: {
                data: { business_type_s: this.businessType },
                errorCount_n: this.status.healthCheckErrorCount,
                type: 'experienceCount',
              },
            });
            // 上报打印机错误数量
            sendDataFn({
              pointId: this.PrinterErrorCount,
              customData: {
                data: { business_type_s: this.businessType },
                errorCount_n: this.status.printerErrorCount,
                type: 'experienceCount',
              },
            });
            // console.log('end', this.businessType, this.status, result, allResult);
            DataCollectorInstance.removeTransactionCollector({
              traceId: this.collector.traceId,
            });
          },
        },
        /**
         * 监听流程耗时结束
         */
      ];
    },
  },
];
